import React, {Component} from 'react';
import toastr from 'toastr';
import Table from '../../components/common/Table';
import {getCurrentUserId, getJwt} from '../../services/authService';
import http from '../../services/httpService';
import {Switch} from "@blueprintjs/core";

const openRateClass = [];
openRateClass[0] = "active above-avg";
openRateClass[1] = "active avg";
openRateClass[2] = "active below-avg";
openRateClass[3] = "active danger";

const facebook_app_graph_url = process.env.REACT_APP_FB_URL;
const facebook_app_marketing_url = process.env.REACT_APP_FB_MARKETING_URL;

class CampaignsTable extends Component {
    state = {
        spinnerActiveForCampaign: ''
    }
    toggleCampaignStatus = async (campaign) => {
        this.setState({
            spinnerActiveForCampaign: campaign.id
        })
        let adsetId = campaign.adsets ? campaign.adsets.data[0].id : '';
        let adData = await http.get(facebook_app_marketing_url + campaign.id + '/ads?access_token=' + this.props.accessToken, {headers: {authorization: getJwt()}});
        let adId = adData.data.data.length > 0 ? adData.data.data[0].id : '';
        let campaignToggle = false;
        let adSetToggle = false;
        let adToggle = false;



        if (adsetId && adId){
            if (campaign && this.props.accessToken) {
                try {
                    const result = await http.post(facebook_app_marketing_url + campaign.id, {
                        "special_ad_categories": "NONE",
                        "name": campaign.name,
                        "objective": campaign.objective,
                        "status": campaign.status !== "ACTIVE" ? "ACTIVE" : "PAUSED",
                        "access_token": this.props.accessToken
                    }, {headers: {authorization: getJwt()}});
                    if (result) {
                        campaignToggle = await true;
                    }
                } catch (ex) {
                    toastr.error("Campaign Status couldn't be changed ");
                }
            }
            if (campaignToggle) {
                try {
                    const result2 = await http.post(facebook_app_marketing_url + adsetId, {
                        "special_ad_categories": "NONE",
                        "status": campaign.status !== "ACTIVE" ? "ACTIVE" : "PAUSED",
                        "access_token": this.props.accessToken
                    }, {headers: {authorization: getJwt()}});
                    if (result2) {
                        adSetToggle = await true;
                    }
                } catch (ex) {
                    toastr.error("Campaign Status couldn't be changed, because there is some problem with AdSet.");
                }
            }

            if (adSetToggle) {
                try {
                    const result3 = await http.post(facebook_app_marketing_url + adId, {
                        "special_ad_categories": "NONE",
                        "status": campaign.status !== "ACTIVE" ? "ACTIVE" : "PAUSED",
                        "access_token": this.props.accessToken
                    }, {headers: {authorization: getJwt()}});
                    if (result3) {
                        adToggle = await true;
                    }
                } catch (ex) {

                    toastr.error("Campaign Status couldn't be changed, because there is some problem with Ad.");
                }
            }

            if (campaignToggle && adSetToggle && adToggle) {
                await this.props.getCampaigns();
                this.setState({
                    spinnerActiveForCampaign: ''
                })
                campaignToggle = await false;
                adSetToggle = await false;
                adToggle = await false;
            } else {
                try {
                    const pausedResult = await http.post(facebook_app_marketing_url + campaign.id, {
                        "special_ad_categories": "NONE",
                        "name": campaign.name,
                        "objective": campaign.objective,
                        "status": "PAUSED",
                        "access_token": this.props.accessToken
                    }, {headers: {authorization: getJwt()}});
                } catch (ex) {

                }
                if (adSetToggle) {
                    try {
                        const pausedResult2 = await http.post(facebook_app_marketing_url + adsetId, {
                            "special_ad_categories": "NONE",
                            "status": "PAUSED",
                            "access_token": this.props.accessToken
                        }, {headers: {authorization: getJwt()}});
                    } catch (ex) {

                    }
                }
                if (adToggle) {
                    try {
                        const pausedResult3 = await http.post(facebook_app_marketing_url + adId, {
                            "special_ad_categories": "NONE",
                            "status": "PAUSED",
                            "access_token": this.props.accessToken
                        }, {headers: {authorization: getJwt()}});
                    } catch (ex) {

                    }
                }
            }
            await this.props.getCampaigns();
        } else {
            if(!adsetId){
                toastr.error('Your adset is not completly set, you can edit it in Ads Manager')
            } else if(!adId){
                toastr.error('Your ad is not completly set, you can edit it in Ads Manager')
            }
        }

        await this.setState({
            spinnerActiveForCampaign: ''
        })
        campaignToggle = await false;
        adSetToggle = await false;
        adToggle = await false;

        // console.log('Toggle data: ', adsetId, adId, campaignToggle, adSetToggle, adToggle)
    }

    getDate = (item) => {
        let date = item ? item.substr(0, item.indexOf('T')) : 'No date';
        return date;
    }

    getTime = (item) => {
        let time = item ? item.substring(item.indexOf('T') + 1, item.indexOf('+')) : 'No time';
        return time;
    }


    render() {

        const {campaigns, onClick, onSort, sortColumn} = this.props;
        const columns = [

            {
                path: "type_of_subscription", label: "",
                content: item =>
                    <div className="details-trigger right">
                        {/*<label className="switch">*/}
                        {/*    <input type="checkbox" checked={item.status !== 'ACTIVE'}/>*/}
                        {/*    <span className="slider round" onClick={() => this.toggleCampaignStatus(item)}></span>*/}
                        {/*</label>*/}

                        <Switch checked={item.status === 'ACTIVE'}

                                onChange={() => this.toggleCampaignStatus(item)}/>
                    </div>
            },
            {
                path: "type_of_subscription", label: "Campaign Name",
                content: item => <p>
                    {item.name}
                </p>
            },
            {
                path: "subscriber_name", label: "Status",
                //content: item => <div><img src={item.profile_pic ? item.profile_pic : "/img/user-default.jpg"} alt="Profile Pic" height="42" width="42"/>
                //    {item.subscriber_name}
                content: item => <div style={{display: 'flex', flexDirection: 'row', alignItems: 'center'}}>
                    {
                        this.state.spinnerActiveForCampaign === item.id ? <i className='fa fa-spin fa-spinner'></i> :
                            <div
                                style={{
                                    borderRadius: 20,
                                    width: 10,
                                    height: 10,
                                    marginRight: 3,
                                    backgroundColor: item.status === 'ACTIVE' ? 'green' : item.status === 'INACTIVE' ? 'red' : 'grey'
                                }}/>
                    }
                    {this.state.spinnerActiveForCampaign === item.id ? null : <p>{item.status}</p>}
                </div>
            },
            {
                path: "type_of_subscription", label: "Budget",
                content: item => <p>${item.daily_budget / 100 || item.lifetime_budget / 100 || 0}</p>
            },
            {
                path: "type_of_subscription", label: "Amount Spent",
                content: item => <div>
                    <p>${Math.round(((item.daily_budget / 100 || item.lifetime_budget / 100 || 0) - item.budget_remaining / 100) * 100) / 100}</p>
                    <div style={{
                        width: "80%",
                        height: "6px",
                        // border:"2px solid rgba(52,74,94,0.9)",
                        backgroundColor: "rgba(214,219,223,1)",
                        position: "relative",
                        borderRadius: "2px"
                    }}>
                        <div
                            style={{
                                width: (1 - Number(item.budget_remaining) / Number(item.daily_budget || item.lifetime_budget || 0)) * 100 + "%",
                                height: "5px",
                                position: "absolute",
                                textAlign: "right",
                                // content:((item.daily_budget/100 || item.lifetime_budget/100 || 0) - item.budget_remaining/100),
                                paddingRight: "10px",
                                color: "white",
                                fontSize: "11px",
                                background: Number(item.budget_remaining) === 0 && (item.daily_budget || item.lifetime_budget) ? "green" : "#26AAE1",
                                top: "0",
                                bottom: "0",
                                left: "0",
                                borderRadius: "10px"
                            }}>
                        </div>
                    </div>
                </div>
            },
            {
                path: "type_of_subscription", label: "Cost Per Click",
                content: item =>
                    <p>${(item.insights && item.insights.data[0].cpc) ? Number(Math.round(item.insights.data[0].cpc + 'e' + 3) + 'e-' + 3) : 0}</p>
            },
            {
                path: "type_of_subscription", label: "Impressions",
                content: item => <p>{item.insights ? item.insights.data[0].impressions : 0}</p>
            },
            {
                path: "type_of_subscription", label: "Reach",
                content: item => <p>{item.insights ? item.insights.data[0].reach : 0}</p>
            },
            {
                path: "type_of_subscription", label: "Click Rate",
                content: item =>
                    <p>{item.insights ? Number(Math.round(item.insights.data[0].ctr + 'e' + 2) + 'e-' + 2) : 0}%</p>
            },
            {
                path: "type_of_subscription", label: "End Date",
                content: item => {
                    return <div>
                        <p style={{marginBottom: 5}}>{this.getDate(item.insights ? item.insights.data[0].date_stop : item.stop_time || item.update_time)}</p>
                        <p style={{color: 'rgb(164, 175, 183)'}}>{this.getTime(item.insights ? item.insights.data[0].date_stop : item.stop_time || item.update_time)}</p>
                        {/*<p>{item.insights ? item.insights.data[0].date_stop : item.stop_time || item.update_time || 'Not Set' }</p>*/}
                    </div>
                }
            },
        ];
        return (
            <div className="table-scroll m-xl-b campaigns-table">
                <Table
                    className='campaign-performance-table'
                    data={campaigns}
                    columns={columns}
                    sortColumn={sortColumn}
                    onSort={onSort}
                    onClick={onClick}/>
            </div>
        );
    }
}

export default CampaignsTable
